export const environment = {
    production: false,
    name: 'stage',
    clientId: '87611d2c-02f2-44b6-a125-b84d2b9f38c3',
    authority: 'https://login.microsoftonline.com/f5c6aec8-b5ac-44bb-b70d-e0a191024efb',
    redirectUri: 'https://stage.intralogistics.io/',
    apiUrl: 'https://galileoiot-api-management.azure-api.net/api',
    apiVersion: '/stage',
    subscriptionKey: '8efd15401beb43318406307e2bf2cd4a',
    signalRConnectionString: 'Endpoint=https://sigr-realtimemessages-dev.service.signalr.net;AccessKey=cPBAqhFcY7aisBP3By3DlIwGThmRAT/RUuA/lLkgT+M=;ClientEndpoint=https://galileoiot.azurewebsites.net;Version=1.0;',
    storageUrl: 'https://galileoiotstoragestage.blob.core.windows.net'
};
